export * from "./presenter";
export * from "./breadcrumb";
export * from "./forms";
export * from "./page-not-found";
export * from './login-failed';
export * from "./filter";
export * from "./list";
export * from "./tree";
export * from "./dropdown";
export * from "./building";
export * from "./carousel";
export * from "./button";

import { NavigationComponents } from './navigation';
import { BreadcrumbComponents, BreadcrumbServices } from './breadcrumb';
import { FormComponents } from './forms';
import { FilterComponents  } from './filter';
import { PageNotFoundComponent } from './page-not-found';
import { LoginFailedComponent } from './login-failed';
import { PresenterComponent } from './presenter';
import { ListComponents } from './list';
import { TreeItemComponent } from './tree';  
import { DropdownComponent } from './dropdown';
import { BuildingComponents } from './building';
import { CarouselComponents } from './carousel';
import { ButtonComponents } from './button';
import { CardComponents } from './card';

export const SharedComponents = [
    ...NavigationComponents,
    ...FilterComponents,
    ...BreadcrumbComponents,
    ...FormComponents,
    ...ListComponents,
    ...BuildingComponents,
    ...CarouselComponents,
    ...ButtonComponents,
    ...CardComponents,
    PageNotFoundComponent,
    LoginFailedComponent,
    PresenterComponent,
    TreeItemComponent,
    DropdownComponent
];

export const SharedComponentServices = [...BreadcrumbServices];
